import {memo} from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {useVendorBreadcrumbs} from "../hooks/use_vendor_breadcrumbs";

export const VendorBreadcrumbs = memo(() => {
    const breadcrumbs = useVendorBreadcrumbs();

    return <Breadcrumbs homePageUrl={rpAppLink.base()} items={breadcrumbs} />;
});
import {memo} from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {useVendorBreadcrumbs} from "../hooks/use_vendor_breadcrumbs";

export const VendorBreadcrumbs = memo(() => {
    const breadcrumbs = useVendorBreadcrumbs();

    return <Breadcrumbs homePageUrl={rpAppLink.base()} items={breadcrumbs} />;
});
